<template>
  <div
    class="avatar-box m-2 d-flex justify-content-center"
    v-if="avatar.id"
    :data-cy="`avatar-image${avatar.id}-component`"
  >
    <div
      :id="'avatar-' + (avatar.active ? 'active' : 'store') + '-' + avatar.id"
      class="avatar-image position-relative d-flex justify-center align-center"
      @click="toggleActiveAvatar"
      :data-cy="`avatar-image${avatar.id}-id`"
    >
      <img
        :src="`https://assets.beereaders.com/avatar/${avatar.name}/${avatar.value}`"
        class="avatar-img transition-all"
        @load="handleLoaded"
        alt="Av"
      />
      <v-overlay absolute :value="!avatar.active" opacity="0">
        <v-row class="mt-12 ml-12" justify="center" align="center">
          <v-img src="/img/user/beecoin-3.svg" height="50" width="50"> </v-img>
        </v-row>
      </v-overlay>
      <div
        class="pa-0 ma-0 avatar-check avatar-check-none white transition-all rounded-circle"
        :id="'avatar-check-' + (avatar.active ? 'active' : 'store') + '-' + avatar.id"
      >
        <em class="mdi mdi-36px mdi-checkbox-marked-circle green--text transition-all pt-2"></em>
      </div>
      <v-skeleton-loader
        v-if="!loaded"
        class="rounded-circle position-absolute opacity-none"
        height="120"
        width="120"
        type="image"
        :transition="'scale-transition'"
      ></v-skeleton-loader>
    </div>
  </div>
</template>

<script>
const defaultAvatar = () => {
  return {
    active: false,
    avatarFormat: '',
    avatarPack: null,
    creationDate: null,
    id: 0,
    name: '',
    ordinalAvatarFormat: 1,
    value: '',
  }
}

export default {
  props: {
    avatar: {
      type: Object,
      default: defaultAvatar,
    },
    selected: { type: Boolean, default: false },
  },
  data() {
    return {
      loaded: false,
    }
  },
  mounted() {
    if (this.selected) {
      this.setActiveAvatar()
    }
    setTimeout(() => {
      this.setToBuy()
    }, 500)
  },
  methods: {
    setToBuy() {
      const avatar = document.querySelector(`#avatar-store-${this.avatar.id} > img`)
      if (!this.avatar.active && avatar) {
        avatar.classList.add('avatar-to-buy')
      }
    },
    setActiveAvatar() {
      const avatar = document.querySelector(`#avatar-active-${this.avatar.id}`)
      avatar.classList.add('avatar-active')

      const check = document.querySelector(`#avatar-check-active-${this.avatar.id}`)
      check.classList.remove('avatar-check-none')
    },
    deselectOthers() {
      const avatar = document.querySelector('.avatar-active')
      avatar.classList.remove('avatar-active')

      const avatarsCheck = document.querySelectorAll('.avatar-check')
      if (avatarsCheck.length > 0) {
        for (let i = 0; i < avatarsCheck.length; i += 1) {
          avatarsCheck[i].classList.add('avatar-check-none')
        }
      }
    },
    toggleActiveAvatar() {
      if (!this.avatar.active) {
        this.$emit('toBuy', this.avatar)
        return
      }
      this.deselectOthers()

      const avatar = this.avatar.active
        ? document.querySelector(`#avatar-active-${this.avatar.id}`)
        : document.querySelector(`#avatar-store-${this.avatar.id}`)

      avatar.classList.add('avatar-active')

      const check = this.avatar.active
        ? document.querySelector(`#avatar-check-active-${this.avatar.id}`)
        : document.querySelector(`#avatar-check-store-${this.avatar.id}`)

      check.classList.remove('avatar-check-none')
      this.$emit('active', this.avatar.id)
    },
    handleLoaded() {
      this.loaded = true
    },
  },
}
</script>

<style lang="css">
.avatar-box,
.avatar-image {
  border-radius: 500px;
}

.avatar-active .avatar-img {
  padding: 0;
}
.avatar-img {
  display: block;
  width: 100%;
}

.avatar-active {
  border: 1vh solid #4caf50;
  border-style: solid;
}

.avatar-check {
  bottom: 0px;
  right: -15px;
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
}

.avatar-check-none {
  display: none;
}
.avatar-to-buy {
  opacity: 0.3;
}
</style>
